/* global __CONFIG__ */
import { all, put, takeLatest, call, select } from 'redux-saga/effects';

import { SIGNUP } from '@coconut/constants/landingRoutes';
import { EVENT_GO_TO_SIGNUP } from '@coconut/constants/userTrackingEvents';

import { getToken } from '@coconut/services/redux/auth';
import { getPreviousLocation } from '@coconut/services/redux/location';
import {
  types,
  home,
  openExternalUrl,
  goToSignup,
} from '@coconut/services/redux/navigation';
import { sendGtmEvent } from '@coconut/services/redux/googleTagManager';

const LANDING_ROOT_PATH = __CONFIG__.SNAPASK_LANDING_ROOT_PATH;
const ACAEMY_ROOT_PATH = __CONFIG__.ACADEMY_SITE_ENDPOINT;

const getLandingURL = (targetPage) => `${LANDING_ROOT_PATH}/${targetPage}`;
const getAcademyUrl = (targetPage) => `${ACAEMY_ROOT_PATH}${targetPage}`;

function* homeFlow(history) {
  yield call(history.push, '/');
}

function* previousFlow(history) {
  const previousRoute = yield select(getPreviousLocation);

  const { pathname } = previousRoute;

  if (pathname) {
    yield call(history.push, pathname);
  } else {
    yield put(home());
  }
}

function* uploadImageFlow(history) {
  yield call(history.push, '/upload/Image');
}

function* landingPageFlow(action) {
  const { path } = action;
  const url = getLandingURL(path);
  yield put(openExternalUrl(url));
}

function* openExternalUrlFlow(action) {
  const {
    payload: { url },
  } = action;

  window.location = url;
}

function* chatRoomFlow(history, action) {
  const {
    payload: { questionId },
  } = action;
  const token = yield select(getToken);

  if (token) {
    yield call(history.push, `/chat/${questionId}`);
  } else {
    yield put(goToSignup());
  }
}

function* signupPageFlow() {
  yield put(sendGtmEvent(EVENT_GO_TO_SIGNUP));
  const url = getLandingURL(SIGNUP);
  yield put(openExternalUrl(url));
}

function* tutorHomeFlow(history) {
  yield call(history.push, '/tutor');
}

function* academyPageFlow(action) {
  const { path } = action;
  const url = getAcademyUrl(path);
  yield put(openExternalUrl(url));
}

export default function* (context) {
  const { history } = context;

  yield all([
    takeLatest(types.HOME, homeFlow, history),
    takeLatest(types.PREVIOUS, previousFlow, history),
    takeLatest(types.UPLOAD_IMAGE, uploadImageFlow, history),
    takeLatest(types.LANDING_PAGE, landingPageFlow),
    takeLatest(types.OPEN_EXTERNAL_URL, openExternalUrlFlow),
    takeLatest(types.CHAT_ROOM, chatRoomFlow, history),
    takeLatest(types.SIGNUP, signupPageFlow),
    takeLatest(types.TUTOR_HOME, tutorHomeFlow, history),
    takeLatest(types.ACADEMY_PAGE, academyPageFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/navigation.js